// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ApiParameter, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { getPriceBook as getPriceBookApi } from "@synd/App/Services/MyPriceBookService";
import { xHasRole } from "@synd/App/Store/Selectors/GeneralSelectors";
import { USER_ROLES } from "@synd/XDL/constants";

type HandlerType = ApiHandlerDiscreteParameter<
    ApiParameter & HasOnSuccess<void> & HasOnError<string>,
    ApiParameter,
    ServiceResult<any>
>;

export const SkipIfHasRetailerRole: HandlerType = props => {
    if (xHasRole(props.getState(), USER_ROLES.RETAILER)) {
        return false;
    }
};
export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getPriceBookApi();
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const chain = [
    SkipIfHasRetailerRole,
    PopulateApiParameter,
    RequestDataFromApi,
    ExecuteOnErrorCallback,
    ExecuteOnSuccessCallback,
];

const getPriceBook = createHandlerChainRunner(chain, "getPriceBook");
export default getPriceBook;
